var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBrandColor48Filled = function SvgIconBrandColor48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.999 11.92 1.251-1.15a1.7 1.7 0 0 0-2.502-.002l1.251 1.152-1.251-1.152-.01.01-.022.026a23.652 23.652 0 0 0-.39.435 66.786 66.786 0 0 0-4.341 5.488c-1.186 1.68-2.4 3.592-3.322 5.508-.907 1.883-1.614 3.93-1.614 5.835 0 6.049 4.9 10.95 10.95 10.95 6.049 0 10.95-4.901 10.95-10.95 0-1.903-.707-3.95-1.614-5.831-.923-1.915-2.136-3.828-3.322-5.508a66.943 66.943 0 0 0-4.73-5.927l-.023-.025-.009-.009L24 11.92Zm3.732 14.62h3.09c0-1.43-1.61-4.43-3.58-7.45l-2.01 2.53c1.95 2.99 2.5 4.46 2.5 4.92Z"
  })));
};
export default SvgIconBrandColor48Filled;